import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoMarkProps {
    className?: string
    inverted?: boolean
}

export const LogoMark: FC<LogoMarkProps> = ({ className, inverted = false }): ReactNode => {
    const tileColor = inverted ? 'var(--background)' : 'var(--primary)'
    const leafColor = inverted ? 'var(--primary)' : 'var(--primary-foreground)'

    return (
        <svg viewBox='0 0 32 32' aria-hidden='true' className={cn('shrink-0', className)}>
            <rect width='32' height='32' rx='9' style={{ fill: tileColor }} />
            <path
                d='M16 5.5c6.2 4 7.6 11.2 3.6 16.8-1.1 1.5-2.3 2.6-3.6 3.2-1.3-.6-2.5-1.7-3.6-3.2-4-5.6-2.6-12.8 3.6-16.8Z'
                style={{ fill: leafColor }}
            />
            <path
                d='M16 9.5v15M16 14.2l2.9-2.5M16 18.4l3.4-2.7M16 14.2l-2.9-2.5M16 18.4l-3.4-2.7'
                style={{ stroke: tileColor, fill: 'none' }}
                strokeWidth='1.3'
                strokeLinecap='round'
            />
            <path d='M16 25.5v2.2' style={{ stroke: leafColor }} strokeWidth='1.3' strokeLinecap='round' />
        </svg>
    )
}

interface LogoProps {
    className?: string
    tone?: 'default' | 'light'
}

export const Logo: FC<LogoProps> = ({ className, tone = 'default' }): ReactNode => {
    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name}، صفحهٔ اصلی`}
            className={cn('inline-flex items-center gap-3 rounded-lg outline-none focus-visible:ring-3 focus-visible:ring-ring/50', className)}
        >
            <LogoMark className='size-10' inverted={tone === 'light'} />

            <span className='flex flex-col gap-1'>
                <span className={cn('font-heading text-[1.7rem] font-semibold leading-none', tone === 'light' ? 'text-background' : 'text-foreground')}>
                    {siteConfig.shortName}
                </span>
                <span className={cn('text-[0.7rem] leading-none', tone === 'light' ? 'text-background/70' : 'text-muted-foreground')}>
                    {siteConfig.tagline}
                </span>
            </span>
        </Link>
    )
}
